import React from 'react';

import styled, { css } from 'styled-components';

import LoyaltyUnockingIcon from '~/icons/components/LoyaltyUnlockingIcon/LoyaltyUnlockingIcon';
import { Separator } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const UnlockedProductWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const UnlockedProductMessage = styled.div`
  font-size: 12px;
  margin-left: 10px;
`;

const UnlockedProductMessageHeading = styled.div`
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 5px;
`;

const separatorStyle = css`
  color: ${({ theme }) => theme.colors.separator};
  margin-block: 14px 16px;
`;

function PlatinumUnlockedMessage() {
  return (
    <>
      <UnlockedProductWrapper data-testid="pdp-platinum-unlocked">
        <LoyaltyUnockingIcon />
        <UnlockedProductMessage>
          <UnlockedProductMessageHeading>
            <FormattedMessage
              id="site_pdp.platinum_exclusive_unlocked_product_heading"
              defaultMessage="Congratulations!"
            />
          </UnlockedProductMessageHeading>
          <FormattedMessage
            id="site_pdp.platinum_exclusive_unlocked_product_content"
            defaultMessage="You’ve unlocked this product with your Platinum VIP Membership status."
          />
        </UnlockedProductMessage>
      </UnlockedProductWrapper>
      <Separator thickness={1} separatorStyle={separatorStyle} />
    </>
  );
}

export default PlatinumUnlockedMessage;
